<template>
    <CCard>
        <CCardBody
            v-show="
                hasItemsInTable({
                    tableName: 'subTags'
                })
            "
        >
            <CContainer class="section" fluid>
                <CRow class="border-bottom">
                    <CCol >
                        <CBreadcrumb class="background-full-white" :items="breadItems"/>
                    </CCol>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="12">
                        <CDataTable
                            :addTableClasses="['table--sm']"
                            :fields="
                                traslateArrayObjects({
                                    array: tables.subTags.fields,
                                    fields: ['label'],
                                })
                            "
                            :itemsPerPageSelect="{
                                values: [5, 10, 20],
                            }"
                            :columnFilterValue.sync="
                                tables.subTags.columnFilterValue
                            "
                            @update:column-filter-value="updateData()"
                            @pagination-change="itemPerPage"
                            :items-per-page="tables.subTags.rows"
                            v-bind="tables.subTags"
                        >
                        </CDataTable>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <NoItemsContainer
            v-show="
                !hasItemsInTable({
                    tableName: 'subTags'
                })
            "
        >
            <template #title>
                Not Found Sub Tags
            </template>
            <template #description>
                {{'Generar una descripción de los sub tags'}}
                <ButtonBack class="mt-4 mr-2" title="Go back" />
            </template>
            <template #cleanFilter>
                <CButton
                    color="primary"
                    class="button"
                    v-show="
                        hasFiltersInTable({
                            tableName: 'subTags' 
                        })
                    "
                    @click="cleanFiltersAdvance('subTags'), updateData()"
                >
                    <span class="button__icon">
                        <CIcon
                            :content="$options.icons.eraser"
                        />
                    </span>
                    <span class="button__text">
                        {{ $t("Clean Filter") }}
                    </span>
                </CButton>
            </template>
        </NoItemsContainer>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import NoItemsContainer from "~/components/NoItemsContainer";
/** Mixins */
import { validationMixin } from "vuelidate";
import tableMixin from "~/mixins/table";
import modalMixin from "~/mixins/modal";
import traslateMixin from "~/mixins/traslate.js";
/** Icons */
import { eraser }  from '~/assets/icons/js/eraser';

/** Others */
import { required } from "vuelidate/lib/validators";
import {
    cilPencil,
    cilCaretBottom,
    cilCaretTop,
    cilSave,
    cilPlus,
    cilTrash
} from "@coreui/icons";

export default {
    name: "SubTag",
    mixins: [validationMixin, traslateMixin, tableMixin, modalMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
        cilPlus,
        cilTrash,
        eraser
    },

    components: {
        ButtonBack,
        ButtonLoading,
        NoItemsContainer
    },

    props: {
        tagUuid: {
            required,
        },
        tagName: {
            required,
        },
        loading: Boolean,
    },

    data() {
        return {
            tables: {
                subTags: {
                    items: [],
                    fields: [
                        {
                            label: "id",
                            key: "id",
                            sorter: false,
                            filter: true,
                        },
                        {
                            label: "name",
                            key: "name",
                            sorter: false,
                            filter: true,
                        },
                        {
                            label: "code",
                            key: "code",
                            sorter: false,
                            filter: true,
                        },
                        {
                            key: "createdAt",
                            label: "created_at",
                            sorter: false,
                            filter: false,
                            _style: "width:20%",
                        }
                    ],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                },
            },
            breadItems:[
                {
                    text: 'Tags',
                    to: '/app/documentation/headers'
                },
                {
                    text: this.tagName
                }
            ]
        };
    },
    watch: {},
    validations: {},
    methods: {
        itemPerPage(newValue) {
            this.tables.subTags.rows = newValue;
            this.updatePagination(this.tables.subTags.page);
        },
        updatePagination(newValue) {
            this.tables.subTags.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "subTags",
                url: `/tags/${this.tagUuid}/sub-tags`,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.subTags.loading = false;
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style>
.background-full-white{
    background-color: #fff;
    border-color: #fff;
}
</style>